<div class="custom-progress-bar-outer">
  <div
    class="custom-progress-bar-inner"
    [ngStyle]="{
      width: (progress / max * 100) + '%',
      background: color
    }"
  ></div>
</div>